<header class="container-fluid" [ngClass]="headerHomeClass">
  <div class="container">
    <mat-toolbar>
      <mat-toolbar-row>
        <img [routerLink]="['/home']" routerLinkActive="router-link-active" class="logo"
          src="assets/img/butterfly-logo.png" />
        <span class="divider"></span>
        <img [routerLink]="['/home']" class="logo" src="assets/img/decision-maker-logo.png" />
        @if (getUserService().currentOrganization?.logo_link) {
        <span class="divider"></span>
        }
        <img class="logo" [src]="getUserService()?.currentOrganization?.logo_link" />
        @if (getUserService().userLoggedIn) {
        <div class="ml-auto cursor user-profile-container" [matMenuTriggerFor]="menu">
          <div class="user-text">
            <div class="user-name">
              @if (getUserService().userDetails?.first_name) {
              <span>
                {{ "components.header.component.hello" | translate }}
                <strong>{{ getUserService().userDetails?.first_name }} {{ getUserService().userDetails?.last_name
                  }}</strong>
              </span>
              }
              @if (!getUserService().userDetails?.first_name) {
              <span>
                {{ "components.header.component.hello" | translate }}
                <strong>{{ getUserService().userInfo?.email }}</strong>
              </span>
              }
            </div>

            @if (getUserService().currentOrganization) {
            <div class="user-org">
              {{ "generic.organization" | translate }}: {{ getUserService().currentOrganization?.name }}
              <mat-icon class="dropdown-arrow">keyboard_arrow_down</mat-icon>
            </div>
            }
          </div>

          <div class="user-avatar-wrapper">
            @if (getUserService().userDetails.avatar_link) {
            <img class="avatar-img-pic" [src]="getUserService()?.userDetails?.avatar_link" />
            }
            @if (!getUserService().userDetails.avatar_link) {
            <div class="avatar-placeholder">
              <i class="icon-Avatar"></i>
            </div>
            }
          </div>

          <!-- Hidden connection to existing menu logic if needed, but matMenuTrigger is now on parent -->
        </div>
        <mat-menu #menu="matMenu">
          <button mat-menu-item [routerLink]="['/profile']">
            <div class="row">
              <div class="col-2 d-flex align-items-center">
                @if (getUserService().userDetails.avatar_link) {
                <img class="avatar-img-pic-menu" [src]="getUserService().userDetails?.avatar_link" />
                }
                @if (!getUserService().userDetails.avatar_link) {
                <mat-icon><i class="icon-Avatar"></i></mat-icon>
                }
              </div>
              <div class="col-9 d-flex justify-content-start">
                <span>{{
                  "components.header.component.show-profile" | translate
                  }}</span>
              </div>
            </div>
          </button>
          <button mat-menu-item [routerLink]="['/organization/all']">
            <div class="row">
              <div class="col-2 ">
                <mat-icon>corporate_fare</mat-icon>
              </div>
              <div class="col-9 d-flex justify-content-start align-items-center">
                <span>{{
                  "components.header.component.change-organization"
                  | translate
                  }}</span>
              </div>
            </div>
          </button>
          @if (isButterflyTeam) {
          <button mat-menu-item [routerLink]="['/user-notes']">
            <div class="row">
              <div class="col-2">
                <mat-icon>notes</mat-icon>
              </div>
              <div class="col-9 d-flex justify-content-start align-items-center">
                <span>{{
                  "components.header.component.user-notes"
                  | translate
                  }}</span>
              </div>
            </div>
          </button>
          }
          @if (currentLang == 'it') {
          <button type="submit" mat-menu-item (click)="useLanguage('en')">
            <div class="row">
              <div class="col-2 d-flex align-items-center">
                <i class="icon-flag-en"><span class="path1"></span><span class="path2"></span><span
                    class="path3"></span><span class="path4"></span><span class="path5"></span><span
                    class="path6"></span><span class="path7"></span><span class="path8"></span><span
                    class="path9"></span><span class="path10"></span><span class="path11"></span><span
                    class="path12"></span></i>
              </div>
              <div class="col-9 d-flex justify-content-start align-items-center">
                <span>{{
                  "components.header.component.change-language" | translate
                  }}</span>
              </div>
            </div>
          </button>
          }
          @if (currentLang == 'en') {
          <button type="submit" mat-menu-item (click)="useLanguage('it')">
            <i class="icon-flag-it"><span class="path1"></span><span class="path2"></span><span
                class="path3"></span></i>
            &nbsp;
            <span>{{
              "components.header.component.change-language" | translate
              }}</span>
          </button>
          }
          <button mat-menu-item class="logout" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>{{ "generic.buttons.logout" | translate }}</span>
          </button>
        </mat-menu>

        }
      </mat-toolbar-row>
      <mat-toolbar-row class="d-flex justify-content-between">
        <h1>{{ pageTitle | translate }}</h1>
        <!-- <button *ngIf="!isHomeRoute() && !isRegisterRoute() && !isBootstrapRoute() && !isLoginRoute()" class="btn-homepage" [routerLink]="['/home']"><i class="icon-Backward-arrow-small"></i> Torna alla homepage</button> -->
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
</header>